<template>
    <div class="vue-survey" v-if="!hide">
        <div class="survey-content">
            <form class="survey-questions">
                <div class="form-input survey-question" v-for="question in questions">
                    <template v-if="question.id === currentDisplay">
                        <label v-html="question.text.en"></label>

                        <template v-if="question.questionType === 'normal'">
                            <input
                               type="text"
                               v-model="answers[question.id]"
                               :placeholder="question.placeholder.en"
                            />

                            <button class="btn btn-primary" @click="submitQuestion">{{ submitText }}</button>
                            <button class="btn" @click="close">{{ closeText }}</button>
                        </template>
                    </template>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "Survey",

    data() {
        return {
            surveyId: 'default',
            questions: [],
            answers: {},
            hide: false,
            currentQuestion: 1,
            currentDisplay: '',
            submitText: Drupal.t('Next'),
            closeText: Drupal.t('Close'),
            postArray: {
                'site_path': window.location.href,
                'language' : 'en'
            },
        }
    },

    mounted() {
        let surveyFinish = this.$cookie.get('survey-finish');
        let showTimes = this.$cookie.get('survey-showed');

        if(_.isEmpty(showTimes)) {
            showTimes = 1;
        }else{
            showTimes++;
        }

        if(!_.isEmpty(surveyFinish) && surveyFinish === this.surveyId) {
            this.hide = true;
        }

        if(showTimes > 5) {
            this.hide = true;
            return;
        }

        this.$cookie.set('survey-showed', showTimes, 30);

        this.getQuestions();
    },

    methods: {
        getQuestions: function () {
            axios.get(`/nl/simple-survey/api/${this.surveyId}/survey-questions`)
                .then(response => {
                    for (const [key, value] of Object.entries(response.data)) {
                        this.questions.push(value);
                    }
                }).finally(() => {
                    this.questions.sort(this.compare)
                    this.currentDisplay = this.questions[0].id;
                })
        },

        compare: function( a, b ) {
            if ( a.id < b.id ){
                return -1;
            }
            if ( a.id > b.id ){
                return 1;
            }
            return 0;
        },

        nextQuestion: function() {
            let next = this.currentQuestion++;

            if(_.isNil(this.questions[next])){
                return false;
            }

            return this.questions[next];
        },

        submitQuestion: function() {
            let nextQuestion = this.nextQuestion();

            if(nextQuestion.questionType === 'closing') {
                for(const [key, a] of Object.entries(this.answers)) {
                    this.postArray[key] = a;
                }

                let postParams = new URLSearchParams(this.postArray);

                axios.post(`/nl/simple-survey/api/${this.surveyId}/submit-questions?${postParams}`).then(response => {
                    this.currentDisplay = nextQuestion.id
                    this.$cookie.set('survey-finish', this.surveyId, 30);
                }).catch(reason => {
                    console.log(reason)
                });
            }else{
                this.currentDisplay = nextQuestion.id
            }
        },

        close: function() {
            this.$cookie.set('survey-finish', this.surveyId, 30);
            this.hide = true;
        }
    }
}
</script>
